import clsx from 'clsx'
import React, { FunctionComponent, ReactNode } from 'react'

import styles from './style.module.scss'

interface CarouselItemProps {
  maxItemsSize: number
  children: ReactNode
}

export const CarouselItem: FunctionComponent<CarouselItemProps> = ({ children, maxItemsSize }) => {
  const classNames = clsx(styles.item, styles[`item-${maxItemsSize}-per-slide`])
  return <li className={classNames}>{children}</li>
}
